import React, { FC, useState } from 'react';
import { Button, InputText } from '@agro1desenvolvimento/react-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RouteComponentProps } from 'react-router-dom';
import ResetPasswordService from '../../services/reset-password';
import notificationsService from '../../services/notifications';
import AuthCard from '../../components/AuthCard';

type PropTypes = RouteComponentProps;

const SendEmailPage: FC<PropTypes> = ({ history }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState('');

  const footer = (
    <>
      <div className="p-text-center auth-footer">
        <Button
          label="Enviar e-mail"
          className="auth-button"
          type="submit"
          form="reset-password-form"
          disabled={loading}
        />

        <div className="p-text-center p-my-5">
          { loading && <FontAwesomeIcon icon="spinner" spin /> }
        </div>
      </div>
    </>
  );

  const validateEmail = (emailValue: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(emailValue);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setEmail(value);
    setEmailError('');
  };

  const handleResetPassword = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!validateEmail(email)) {
      setEmailError('E-mail inválido');
      return;
    }

    try {
      setLoading(true);
      setEmailError('');
      await ResetPasswordService.sendEmail(email);
      notificationsService.success({ message: 'Email de redefinição enviado com sucesso.' });
      history.push('/login');
    } catch (error: any) {
      console.error(error);
      const errorMessage = error?.response?.data?.message || 'Erro ao enviar e-mail. Verifique se o e-mail está correto.';
      setEmailError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="Recuperação de senha" footer={footer}>
      <form onSubmit={handleResetPassword} id="reset-password-form">
        <div className="p-col-12 auth-field">
          <label htmlFor="email" className="auth-label">
            Email
          </label>
          <div className="auth-input-container">
            <FontAwesomeIcon
              icon="user"
              className="auth-icon"
            />
            <InputText
              id="email"
              autoFocus
              required
              value={email}
              title="Email"
              placeholder="Digite seu email"
              className="auth-input"
              onChange={handleEmailChange}
            />
          </div>
          {emailError && (
            <small style={{ color: 'red', marginTop: '0.25rem', display: 'block' }}>
              {emailError}
            </small>
          )}
        </div>
      </form>
    </AuthCard>
  );
};

export default SendEmailPage;
